















import { Component } from "vue-property-decorator";
import Header from "@/components/header/MLoginHeader.vue";
import ManagementCategory from "@/components/ManagementCategory.vue";
import ManagementContent from "@/components/ManagementContent.vue";
import ManagementSection from "@/components/ManagemantSection.vue";
import Footer from "@/components/Footer.vue";
import CheckAdminLogin from "@/utils/CheckAdminLogin";

@Component({
  components: {
    Header,
    ManagementCategory,
    ManagementContent,
    ManagementSection,
    Footer,
  },
})
export default class MMaterialRegister extends CheckAdminLogin {}
